
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

@Component({
    selector: 'app-log-out',
    templateUrl: './log-out.component.html',
    styleUrls: ['./log-out.component.scss'],
    imports: [
        RouterLink
    ]
})
export class LogOutComponent implements OnInit {
  constructor(private _route: Router) {}

  ngOnInit(): void {}

  login(): void {
    this._route.navigateByUrl('/home');
  }
}
